import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import s from './FolderCardFooter.scss';
const FolderCardFooter = ({ folder , size , className , totalDeviationCount , isLocked , statsClassName , withCommentsCount , withPremiumShownNextToTitle , withPrice , oneLineDescription , showCountsWithoutCaptions , children , t  })=>{
    var _folder_premiumFolderData, _folder_premiumFolderData1, _folder_premiumFolderData2;
    const isPaid = ((_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.type) === 'paid';
    const withSubscribersCount = isPaid;
    const { formattedDollarPrice  } = normalizePremiumFolderData(folder.premiumFolderData);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], oneLineDescription && s['one-line-description'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, withPremiumShownNextToTitle && /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
        size: IconSize.SMALL,
        className: s['premium-icon'],
        premiumFolderData: folder.premiumFolderData
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: s['folder-name'],
        title: folder.name
    }, folder.name), isLocked && /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        className: s['lock-icon'],
        tooltipText: t('folderCard.locked'),
        positionFixed: true,
        width: 220
    }, /*#__PURE__*/ React.createElement(LockIcon, {
        size: IconSize.MEDIUM,
        condensed: true
    })), withPrice && isPaid && /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formattedDollarPrice)), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['stats'], statsClassName)
    }, showCountsWithoutCaptions ? totalDeviationCount : t('folderCard.stats.artworks', {
        count: totalDeviationCount
    }), withCommentsCount && !withSubscribersCount && /*#__PURE__*/ React.createElement(React.Fragment, null, ' | ', showCountsWithoutCaptions ? folder.commentCount : t('folderCard.stats.comments', {
        count: folder.commentCount
    })), withSubscribersCount && /*#__PURE__*/ React.createElement(React.Fragment, null, ' | ', showCountsWithoutCaptions ? (_folder_premiumFolderData1 = folder.premiumFolderData) === null || _folder_premiumFolderData1 === void 0 ? void 0 : _folder_premiumFolderData1.numSubscribers : t('folderCard.stats.subscribers', {
        count: (_folder_premiumFolderData2 = folder.premiumFolderData) === null || _folder_premiumFolderData2 === void 0 ? void 0 : _folder_premiumFolderData2.numSubscribers
    })))), children);
};
export default withTranslation()(FolderCardFooter);
